import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import HeaderDateRangePicker from '../shared/HeaderDateRangePicker'
import TriggeredAlertsTab from '../Alerts/TriggeredAlerts/TriggeredAlertsTab'

const EMPTY_COLLECT_IDS = []

const HEADER_CLASS = 'tw:flex! tw:items-center tw:justify-between tw:gap-3 tw:mb-4 tw:pb-3 '
  + 'tw:border-b tw:border-solid tw:border-gray-200'
const TITLE_CLASS = 'tw:m-0! tw:text-base! tw:font-semibold! tw:leading-normal tw:text-gray-900!'

// Reuses the per-collect TriggeredAlertsTab with an organization scope: cross-collect data and a picker.
const OrganizationAlerts = ({ collects, dateRange, initialColumnPreferences, isAdmin }) => {
  const scope = useMemo(() => (
    { kind: 'organization', collectIds: EMPTY_COLLECT_IDS, collects }
  ), [collects])

  return (
    <>
      <header className={HEADER_CLASS}>
        <h1 className={TITLE_CLASS}>Alertes</h1>
        {dateRange ? (
          <HeaderDateRangePicker
            maxDate={dateRange.max}
            minDate={dateRange.min}
            showPresets
          />
        ) : null}
      </header>
      <TriggeredAlertsTab
        initialColumnPreferences={initialColumnPreferences}
        isAdmin={isAdmin}
        scope={scope}
      />
    </>
  )
}

OrganizationAlerts.propTypes = {
  collects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })),
  dateRange: PropTypes.shape({
    max: PropTypes.string.isRequired,
    min: PropTypes.string.isRequired
  }),
  initialColumnPreferences: PropTypes.shape({}),
  isAdmin: PropTypes.bool
}

OrganizationAlerts.defaultProps = {
  collects: [],
  dateRange: null,
  initialColumnPreferences: null,
  isAdmin: false
}

export default OrganizationAlerts
